import React, { useCallback, useEffect, useState } from 'react'
import EffortAndConductDialog from './Dialog'
import { Alert, Box, Typography } from '@mui/material'
import List from './List'
import { useSelector } from 'react-redux'
import ButtonStartIcon from '../../../../../button/ButtonStartIcon'
import { handlerErrorV2 } from '../../../../../../utils/errors'
import InputField from '../../../../../FormControl/input/InputField'
import { getSettingSubModule } from '../../../../../../services/periodical-report/periodical-report-setting.service'
import SelectField from '../../../../../FormControl/input/SelectField'

const EffortAndConduct = ({ curriculum, isLoadingCurriculum }) => {
  const [modal, setModal] = useState(null)
  const [update, setUpdate] = useState(false)
  const [list, setList] = useState([])
  const [listTemp, setListTemp] = useState([])
  const [isLoadingList, setIsLoadingList] = useState(false)
  const [filter, setFilter] = useState({})
  const [error, setError] = useState(null)
  const permission = useSelector(
    (state) => state?.session?.permissions?.['periodical-report-effort-and-conduct'] || {}
  )

  const onLoad = useCallback(async () => {
    setIsLoadingList(true)
    try {
      const response = await getSettingSubModule('effort-and-conduct', filter)
      if (!response?.data && response?.error) {
        setError(response.error.message || 'An error ocurred')
      } else {
        setList(response?.data || null)
        setListTemp(response?.data || null)
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setError(message)
    } finally {
      setIsLoadingList(false)
    }
  }, [])

  const onSearch = (key, value) => {
    setFilter({ ...filter, [key]: value })
    if (value.length === 0) {
      setList(listTemp)
    } else if (key === 'type') {
      const filterData = listTemp.filter((item) => item.type === value)
      setList(filterData)
    } else {
      const filterData = listTemp.filter(
        (item) =>
          item.name.toLowerCase().includes(value.toLowerCase()) ||
          item.code.toLowerCase().includes(value.toLowerCase())
      )
      setList(filterData)
    }
  }

  useEffect(() => {
    onLoad()
  }, [onLoad, update])

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          EffortAndConducts
        </Typography>
        {!isLoadingList && permission['created'] && (
          <ButtonStartIcon
            onClick={() => setModal({ type: 'create', form: {} })}
            color='secondary'
            variant='contained'
            startIcon={['fas', 'plus']}
          >
            Create
          </ButtonStartIcon>
        )}
      </Box>
      <div className='flex gap-2 items-center justify-between items-center py-2'>
        <div className='flex gap-2 justify-start'>
          <ButtonStartIcon
            variant='text'
            startIcon='bars-filter'
            title='Filter'
            color='primary'
            classNameIcon='text-3xl'
            size='large'
          >
            Filter
          </ButtonStartIcon>

          <div className='max-w-250px'>
            <InputField placeholder='Search' onChange={(e) => onSearch('search', e.target.value)} />
          </div>
        </div>
      </div>
      <Box className='px-2 py-2 absolute top-24 bottom-0 inset-x-0'>
        {error ? (
          <Alert severity='error'>{error}</Alert>
        ) : (
          <List
            isLoading={isLoadingList || isLoadingCurriculum}
            list={
              list
                ?.sort((a, b) => a.position - b.position)
                ?.map((item) => {
                  const curriculumData = curriculum?.find((cur) => cur._id === item.curriculumId)
                  return { ...item, curriculum: curriculumData?.name || 'General' }
                }) || []
            }
            permissions={permission}
            onAction={(type, form) => setModal({ type, form })}
          />
        )}
      </Box>
      {modal && (
        <EffortAndConductDialog
          type={modal.type}
          show={!!modal}
          onClose={() => setModal(null)}
          formData={modal.form}
          onReset={() => setUpdate(!update)}
          curriculumList={curriculum}
        />
      )}
    </>
  )
}

export default EffortAndConduct
